import { render, staticRenderFns } from "./ttshop_evaluate.vue?vue&type=template&id=fdf0c8d6&scoped=true&"
import script from "./ttshop_evaluate.vue?vue&type=script&lang=js&"
export * from "./ttshop_evaluate.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_evaluate.vue?vue&type=style&index=0&id=fdf0c8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf0c8d6",
  null
  
)

export default component.exports